import React, { useEffect, useRef } from "react";
import logo from "../../../assets/images/logo.png";
import MachineItem from "./MachineItem_Grid/MachineItem";
import MachineItemTile from "./MachineItem_Tile/MachineItemTile";
import { Row, Select } from "antd";
import {
  sizePad,
  sizeMobile,
  VIEWMODE,
} from "../../../services/common/constants";

const { Option } = Select;

function MachineItemContainer(props) {
  const {
    machineList,
    viewMode,
    customerInfo,
    customer_id,
    group_id,
    group_ids,
    onClickMachine,
    operatorList,
    shift = 0,
    shifts = ["00:00-24:00", "", "", ""],
    setShift,
  } = props;
  const { screenSize } = props;
  const showShiftDropdown = setShift != null;

  let validMachineList = [];
  if (customerInfo != undefined) {
    const group = customerInfo.groupInfo.find((x) => x.id == group_id);
    if (group != undefined) {
      const avail_machine_ids = group.machine_list.split(",");
      validMachineList = machineList.filter((x) =>
        avail_machine_ids.includes(x.machine_id)
      );
    } else {
      if (!group_ids || group_ids === "") {
        validMachineList = machineList;
      } else {
        const avail_group_ids = group_ids.split(",");
        avail_group_ids.forEach(id => {
          const group = customerInfo.groupInfo.find((x) => x.id == id);
          if (group && group.machine_list) {
            const avail_machine_ids = group.machine_list.split(",");
            let mList = machineList.filter((x) =>
              avail_machine_ids.includes(x.machine_id)
            );
            validMachineList = [...validMachineList, ...mList];
          }
        });
      }
    }
  }

  const uniqueArray = validMachineList.filter((item, index) => {
    return validMachineList.indexOf(item) === index;
  });

  const machineUIList = uniqueArray.map((item) => {
    if (viewMode == VIEWMODE.listView) {
      return (
        <MachineItem
          key={machineList.indexOf(item)}
          machineInfo={item}
          customer_id={customer_id}
          customerInfo={customerInfo}
          onClickMachine={onClickMachine}
          operatorList={operatorList}
          screenSize={screenSize}
        />
      );
    } else {
      return (
        <MachineItemTile
          key={machineList.indexOf(item)}
          machineInfo={item}
          customer_id={customer_id}
          customerInfo={customerInfo}
          onClickMachine={onClickMachine}
          operatorList={operatorList}
          screenSize={screenSize}
        />
      );
    }
  });

  return (
    <div className="content-page">
      {showShiftDropdown && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 12,
            paddingRight: 8,
          }}
        >
          <Select
            className="page-changer-style"
            style={{ width: 200, textAlign: "left" }}
            dropdownClassName="page-changer-style-dropdown"
            value={shift}
            onChange={(e) => setShift(e)}
          >
            <Option className="page-changer-item" key="shift-0" value={0}>
              24 Hours
            </Option>
            <Option className="page-changer-item" key="shift-1" value={1}>
              Shift 1 ({shifts.length > 1 ? shifts[1] : ""})
            </Option>
            <Option className="page-changer-item" key="shift-2" value={2}>
              Shift 2 ({shifts.length > 2 ? shifts[2] : ""})
            </Option>
            <Option className="page-changer-item" key="shift-3" value={3}>
              Shift 3 ({shifts.length > 3 ? shifts[3] : ""})
            </Option>
          </Select>
        </div>
      )}
      <div
        style={{
          minHeight:
            screenSize.height -
            100 -
            (screenSize.width >= sizePad
              ? 80
              : screenSize.width >= sizeMobile
                ? 60
                : 50),
        }}
      >
        <Row justify={"start"} align={"top"} gutter={16}>
          {machineUIList}
        </Row>
      </div>
    </div>
  );
}

export default MachineItemContainer;
